"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ChatIcon_module_css_1 = __importDefault(require("./ChatIcon.module.css"));
/**
 * Chat Icon
 */
function ChatIcon() {
    const titleId = "chat-title-id";
    return ((0, jsx_runtime_1.jsxs)("svg", { width: "22", height: "24", viewBox: "0 0 22 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: ChatIcon_module_css_1.default.icon, "aria-describedby": titleId, children: [(0, jsx_runtime_1.jsx)("title", { id: titleId, children: "Try the new Snapchat on web to chat" }), (0, jsx_runtime_1.jsx)("path", { d: "M15.7405 19.6443L15.4875 19.4743H15.1828H5.83333C3.40097 19.4743 1.5 17.592 1.5 15.3557V5.11858C1.5 2.88229 3.40097 1 5.83333 1H16.5C18.9324 1 20.8333 2.88229 20.8333 5.11858V20.4743V22.9732C20.8324 22.9745 20.8309 22.9764 20.8285 22.9787C20.8184 22.9884 20.7986 23 20.7667 23C20.7436 23 20.7247 22.993 20.7126 22.9849L15.7405 19.6443Z", strokeWidth: "2" })] }));
}
exports.ChatIcon = ChatIcon;
//# sourceMappingURL=index.js.map